export default "__VITE_ASSET__BExK9Qqf__"